module.exports = __webpack_public_path__ + "media/images/admin/icons/file-plus-cc2671b5bb1e94f9a5de4c2cc888e6e0.svg";